// scroll-handler.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScrollHandlerService {
  showBottomSheet = false;
  lastScrollTop = 0;
  scrollHideThreshold = 1000;

  handleScroll(scrollTop: number): boolean {
    if (scrollTop > this.scrollHideThreshold) {
      this.showBottomSheet = false;
    } else {
      this.showBottomSheet = true;
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    return this.showBottomSheet;
  }
}
